import { countryOptions, professionOptions, shareStudyViaOptions } from '../../../core';
import { FrontdeskPractitionerFormInputs } from '../types';

export const renderDefaultAdminBookingPractitionerInputValues = (
  data?: FrontdeskPractitionerFormInputs
) => {
  const countryDefault = countryOptions.find((item) => item.value === data?.country);
  const professionDefault = professionOptions.find((item) => item.value === data?.profession);
  const shareStudyViaDefault = shareStudyViaOptions.find((item) =>
    typeof data?.sharedMethod === 'string'
      ? item.value === data?.sharedMethod
      : item.value === data?.sharedMethod?.value
  );

  return {
    salutation: data?.salutation || '',
    firstName: data?.firstName || '',
    lastName: data?.lastName || '',
    title: data?.title || '',
    profession: professionDefault || '',
    practiceName: data?.practiceName || '',
    locationName: data?.locationName || '',
    address: data?.address || '',
    address2: data?.address2 || '',
    country: countryDefault || '',
    state: data?.state || '',
    city: data?.city || '',
    postalCode: data?.postalCode || '',
    phoneNumber: data?.phoneNumber || '',
    faxNumber: data?.faxNumber || '',
    emailAddress: data?.emailAddress || '',
    sharedMethod: shareStudyViaDefault || '',
    isPrimary: data?.isPrimary || false,
  };
};
